import Footer from "web/react/components/footer/footer";
import ClassicFooter from "web/react/components/classic-footer/classic-footer";
import ClassicHomepageLayout from "web/react/components/classic-homepage-layout/classic-homepage-layout";
import HomepageOverlay from "web/react/components/homepage-overlay/homepage-overlay";
var components = {
  Footer: Footer,
  ClassicFooter: ClassicFooter,
  ClassicHomepageLayout: ClassicHomepageLayout,
  HomepageOverlay: HomepageOverlay
};
export default components;